import React from 'react'
import { PageFooterEnterprise, AppToolbarEnterprise } from '../../../components'
import { Outlet } from 'react-router-dom'
import { Container, Grid } from '@mui/material'
import { useStyles } from './style'

const EnterprisePrimaryLayout = () => {
  const classes = useStyles()
  return (
    <>
      <Container className={classes.appBarContainer} maxWidth={false} id='appbar-container'>
        <AppToolbarEnterprise />
      </Container>
      <Grid
        container
        direction='column'
        wrap='nowrap'
        className={classes.container}
      >
        <Grid item className={classes.mainContainer}>
          <main>
            <Outlet />
          </main>
        </Grid>
        <Grid item className={classes.footerContainer}>
          <footer>
            <PageFooterEnterprise />
          </footer>
        </Grid>
      </Grid>
    </>
  )
}

export default EnterprisePrimaryLayout
